module.exports = __webpack_public_path__ + "static/media/Gulp.f23f425d.png";